export default {
  password: { '*': 0 },
  password_repeat: { '*': 0 },
  salutation: { '*': 1, val: 'herr' },
  title: { '*': 0 },
  firstname: { '*': 1 },
  surname: { '*': 1 },
  is_freelancer: { '*': 0, type: 'bool' },
  publication: { '*': 1 },
  company: { '*': 1 },
  department: { '*': 1 },
  position: { '*': 1 },
  post_box: { '*': 1 },
  address: { '*': 1 },
  zip: { '*': 1 },
  address_type: { '*': 1 },
  city: { '*': 1 },
  country: { '*': 1 },
  phone: { '*': 1 },
  mobile_phone: { '*': 0 },
  social_web: { '*': 0 },
  social_xing: { '*': 0 },
  social_linkedin: { '*': 0 },
  social_facebook: { '*': 0 },
  social_twitter: { '*': 0 },
  social_instagram: { '*': 0 },
  is_journalist: { '*': 0 },
  is_blogger: { '*': 0 },
  activity_journalist: { '*': 0 },
  activity_blogger: { '*': 0 },
  activity_other: { '*': 0 },
  contact_via_phone: { '*': 1, type: 'bool' },
  contact_via_address: { '*': 1, type: 'bool' },
  event_subscription: { '*': 0 },
};



// WEBPACK FOOTER //
// ./src/pages/user-profile/form-data.js